import React from "react";

interface HeaderNameActionsProps {
    name: React.ReactNode;
    actions: React.ReactNode;
}

export const HeaderNameActions: React.FC<HeaderNameActionsProps> = props => {
    const { name, actions } = props;

    return (
        <div className="flex min-w-0 flex-wrap items-center flex-1 gap-x-3 gap-y-2">
            <div className="flex min-w-0 items-center">{name}</div>
            {actions ? (
                <div className="flex flex-shrink-0 flex-wrap items-center gap-2">
                    {actions}
                </div>
            ) : null}
        </div>
    );
};
